import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    width: 335,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  image: {
    width: '100%',
    padding: '0 !important',
    margin: 0,
  },
  gridContainer: {
    height: 476,
    maxHeight: 476,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 197px)',
    },
  },
  eventsHolder: {
    flex: 1,
    width: '100%',
    margin: 0,
    padding: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  accordionCard: {
    margin: '5px',
    '&.Mui-expanded': {
      margin: '0px 5px',
    },
  },
}))

export default styles
